import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { AlertDialogState } from "../../reducers/components/AlertDialogReducer";
import { RootState } from "../../reducers/index";
import useStyles from "./AlertDialog.css";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { style } from "@material-ui/system";

export default function AlertDialog() {
  const classes = useStyles();
  const alerDialogData = useSelector<RootState, AlertDialogState>(
    (state) => state.alertDialogDetails
  );
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch({
      type: "CLOSE_ALERT_DIALOG",
      payload: [],
    });
  };

  const getBtnColor = (btnIndex: number, colorCode: string) => {
    if(colorCode == "green") return classes.greenBtnWrapper
    else if(colorCode == "gray") return classes.grayBtnWrapper
    else if(btnIndex == 1) return classes.greenBtnWrapper
    else if(btnIndex == 2) return classes.grayBtnWrapper
  };

  return (
    <div>
      <Dialog
        open={alerDialogData.open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.popUpHeader} id="alert-dialog-title">
          {alerDialogData.title}
        </DialogTitle>
        <DialogContent className={classes.NoPopWrapper}>
          <DialogContentText id="alert-dialog-description">
            {alerDialogData.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div style={{ margin: "20px ​10px 15px 0" }}>
            <div className={getBtnColor(1, alerDialogData.btnOneColor)}>
              <Button onClick={alerDialogData.btnOneOnclick} color="primary">
                {/* <CheckCircleIcon></CheckCircleIcon> */}
                {alerDialogData.btnOnetext}
              </Button>
            </div>
            <div className={getBtnColor(2, alerDialogData.btnTwoColor)}>
              <Button
                onClick={alerDialogData.btnTwoOnclick} color="primary"
                autoFocus>
                {alerDialogData.btnTwotext}
              </Button>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
